import React from 'react';
import { Route } from 'react-router-dom';
import { StocksLoadingDialog } from './stocks-loading-dialog/StocksLoadingDialog';
import { StockDeleteDialog } from './stock-delete-dialog/StockDeleteDialog';
import { StocksUIProvider } from './StocksUIContext';
import StocksCard from './StocksCard';

const StocksPage = ({ history }) => {
  const StocksUIEvents = {
    openCreateStockDialog: () => {
      history.push('/stocks/new');
    },
    openViewStockDialog: (id) => {
      history.push(`/stocks/${id}/edit`);
    },
    openDeleteStockDialog: (id) => {
      history.push(`/stocks/${id}/delete`);
    },
  };

  return (
    <StocksUIProvider StocksUIEvents={StocksUIEvents}>
      <StocksLoadingDialog />
      <Route path='/stocks/:id/delete'>
        {({ history, match }) => (
          <StockDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/stocks');
            }}
          />
        )}
      </Route>
      <StocksCard props />
    </StocksUIProvider>
  );
};

export default StocksPage;
